import React from 'react';
import { BaseImage } from '@/components/ui/BaseImage';
import logoImg from 'public/assets/images/logo.png';
import { FooterLinks } from './FooterLinks';

export const LegalFooter: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__content">
        <aside className="footer__left">
          <span>
            <BaseImage
              src={logoImg.src}
              alt="Snappy Logo"
              width={145}
              height={32}
              layout="fixed"
              className="footer__logo"
            />
          </span>
          <div className="footer__disclaimer">
            ©{currentYear} Snappy App, Inc. All Rights Reserved
          </div>
        </aside>
        <aside className="footer__right">
          <FooterLinks />
        </aside>
      </div>

      {/* Style */}

      <style jsx>
        {`
          .footer {
            @apply relative flex flex-none w-full py-8 h-auto;

            &__content {
              @apply flex flex-col md:flex-row items-start justify-between h-full;
              @apply container px-6 xl:px-3;
            }

            &__left {
              @apply flex flex-col items-start md:items-start pb-12 md:pb-0;
            }

            &__right {
              @apply flex flex-col items-start justify-end md:items-end h-full;
            }

            &__disclaimer {
              @apply font-dm-sans leading-normal mt-2;
              @apply text-xs text-primary-700;
            }

            &__logo {
              @apply w-[100px] h-[22px];
            }
          }
        `}
      </style>
    </footer>
  );
};
